{
  "filters": {
    "address": "Address",
    "update": "Update",
    "name": "Institution name",
    "state": "State",
    "any": "Any",
    "approved": "Approved",
    "rejected": "Rejected",
    "awaitingReview": "Awaiting review",
    "requestedDate": "Requested date",
    "approvedDate": "Approved date",
    "daysWaiting": "Days waiting",
    "document": "Document",
    "transitNumber": "Transit number",
    "institutionNumber": "Institution number",
    "bankAccountNumber": "Bank account number",
    "actions": "Actions",
    "stateOptions": {
      "AWAITING_REVIEW": "Awaiting review",
      "APPROVED": "Approved",
      "REJECTED": "Rejected"
    }
  },
  "institutionTransitions": {
    "approve": "Approve",
    "reject": "Reject"
  },
  "update": "Update",
  "moderateInstitution": "Are you sure?",
  "confirmationDialogTitle": "Are you sure you want to {{transition}} this institution?",
  "institutionPrefix": "Institution -",
  "addModal": {
    "title": "Create new Institution",
    "address": "Address"
  }
}
